import React from 'react';
import PropTypes from 'prop-types';
import { Spin } from 'antd';

const FullScreenSpinner = ({ children }) => (
  <div className="flex flex-grow justify-center">
    <div className="flex flex-col justify-center items-center">
      <Spin />
      {children}
    </div>
  </div>
);

const LoaderSpinner = ({ children, className, size }) => (
  <div className={`loading-spinner flex flex-col justify-center text-center ${className}`}>
    <Spin size={size} className="mr-2 mb-2"/>
    <span className={`${size === 'small' ? 'text-xs' : ''}`}>
      {children}
    </span>
  </div>
);

const Loader = (props) => {
  if (props.fullScreen) {
    return <FullScreenSpinner children={props.children} />
  }
  return <LoaderSpinner {...props} />
}

Loader.propTypes = {
  className: PropTypes.string,
  size: PropTypes.string,
  fullScreen: PropTypes.bool,
}

Loader.defaultProps = {
  className: '',
  size: 'default',
  fullScreen: false,
};

export default Loader;


